/**
 * ONE Google place.
 *
 * This used to resolve between the unified page and the legacy Google Integration
 * page, because both existed during the slice-1..3 rollout and hard-coding either
 * one would have given the app two Google pages depending on which link you
 * clicked.
 *
 * That decision is settled: isUnifiedGoogleEnabled() had been a hardcoded true
 * since the unified page shipped, backend flipped the three prod Google flags on
 * 2026-08-26, and the prod OAuth callback URI was confirmed working on 2026-08-27
 * — which was this helper's stated condition for retirement. So it is a constant
 * now, and resolving it is no longer asynchronous.
 *
 * That asynchrony was not free: Dashboard seeded its Google link with
 * GOOGLE_LEGACY_PATH and swapped it after the promise resolved, so clicking
 * quickly enough took you to the legacy page.
 *
 * The legacy page is still ROUTED and still works — it just isn't linked from
 * anywhere. Deleting it is a separate decision.
 */
export const GOOGLE_UNIFIED_PATH = '/dashboard/google';
export const GOOGLE_LEGACY_PATH = '/dashboard/google-analytics';

/** The Google destination. Kept as a function so existing call sites don't change. */
export const googleIntegrationPath = () => GOOGLE_UNIFIED_PATH;

export default googleIntegrationPath;

/**
 * The Google page opened ON one account, with one permission's Allow ready
 * (GoogleAccounts reads ?account= & ?allow= once). Get Found's tabs link here:
 * every account and permission is managed on that page only.
 *   service  'analytics' | 'searchConsole' | 'businessProfile' | ''
 */
export function googleIntegrationHref({ account = '', service = '' } = {}) {
    const q = new URLSearchParams();
    if (account) q.set('account', account);
    if (service) q.set('allow', service);
    const s = q.toString();
    return s ? `${GOOGLE_UNIFIED_PATH}?${s}` : GOOGLE_UNIFIED_PATH;
}
